import React from 'react';
import { NavLink } from 'react-router-dom';
import { isSuperMaster } from '../../utils/auth';
import './AdminSidebar.css';

const AdminSidebar = ({ isOpen, onClose }) => {
  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊', exact: true },
    { path: '/admin/bookings', label: 'Bookings', icon: '📋' },
    { path: '/admin/payments', label: 'Payments', icon: '💳' },
    { path: '/admin/therapists', label: 'Therapists', icon: '💆' },
  ];

  if (isSuperMaster()) {
    menuItems.push({ path: '/admin/users', label: 'Users', icon: '👥' });
  }

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <span className="sidebar-logo-icon">💆</span>
          <span className="sidebar-logo-text">Admin Panel</span>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              <span className="sidebar-link-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default AdminSidebar;
